"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.enhance = void 0;

var _flowRight = _interopRequireDefault(require("lodash/flowRight"));

var _addOverlayControls = _interopRequireDefault(require("eventbrite_design_system/structure/hoc/addOverlayControls"));

var _addMainControls = _interopRequireDefault(require("eventbrite_design_system/structure/hoc/addMainControls"));

var _addFocusDrawerControls = _interopRequireDefault(require("eventbrite_design_system/structure/hoc/addFocusDrawerControls"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Enhances a component (typically `SiteStructure`) with useful HOC controls.
 * Also useful for enhancing mock components in unit tests.
 * @param {import('react').Component} component The component to enhance
 * @returns {import('react').Component} Enhanced component
 */
var enhance = (0, _flowRight.default)(_addOverlayControls.default, _addMainControls.default, _addFocusDrawerControls.default);
exports.enhance = enhance;
//# sourceMappingURL=utils.js.map